<template>
  <div>
    <v-flex xs12 sm12 md12>
      <Filters />
    </v-flex>
    <v-flex xs12 sm12 md12 class="align-content-end">
      <PowerPlantDetails />
    </v-flex>
    <v-flex xs12 sm12 md12>
      <v-container fill-height fluid>
        <v-layout row wrap>
          <v-flex xs12 sm12 md4>
            <EnergyDetails />
          </v-flex>
          <v-flex xs12 sm12 md8>
            <BillingChart />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex xs12 sm12 md12>
      <v-container fill-height fluid>
        <v-layout row wrap>
          <v-flex xs12 sm12 md8>
            <FinancialDetails />
          </v-flex>
          <v-flex xs12 sm12 md4>
            <BillingResult />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import Filters from "../../components/billing/Filters";
// import BillingDetails from '../../components/billing/BillingDetails'
import BillingChart from "../../components/billing/BillingChart";
import PowerPlantDetails from "../../components/billing/PowerPlantDetails";
import EnergyDetails from "../../components/billing/EnergyDetails";
import FinancialDetails from "../../components/billing/FinancialDetails";
import BillingResult from "../../components/billing/BillingResult";
// import BillingDetails from '../../components/billing/BillingDetails'
export default {
  components: {
    Filters,
    // BillingDetails,
    BillingChart,
    PowerPlantDetails,
    EnergyDetails,
    FinancialDetails,
    BillingResult,
  },
};
</script>
<style scoped></style>
